import React from 'react';

const DuckIcon = (props) => (
  <svg width='32' height='32' viewBox='0 0 32 32' {...props}>
    <g fill='currentColor' fillRule='nonzero'>
      <g transform='translate(6.000000, 6.000000)'>
        <path d='M6.5,3 C5.67157288,3 5,3.67157288 5,4.5 C5,5.32842712 5.67157288,6 6.5,6 C7.32842712,6 8,5.32842712 8,4.5 C8,3.67157288 7.32842712,3 6.5,3 M8,0 C10.7614237,0 13,2.23857625 13,5 C13,6.7 12.15,8.2 10.86,9.1 C12.44,9.25 14.22,9.61 16,10.5 C19,12 20,10 20,10 C20,10 19,19 13,19 L7,19 C7,19 2,19 2,14 C2,11 5,10 4,8 C0,8 0,4.5 0,4.5 C1,5 2.24,5 3,4.65 C3.19,2.05 5.36,0 8,0 Z' />
      </g>
    </g>
  </svg>
);

export default DuckIcon;
